document.addEventListener('DOMContentLoaded', function() {
  // Listen for clicks on Globo swatches
  document.addEventListener('click', function(e) {
    const swatchLabel = e.target.closest('.swatch-anchor');
    if (!swatchLabel) return;

    const swatchInput = swatchLabel.previousElementSibling;
    if (!swatchInput || swatchInput.type !== 'radio') return;

    // Get the product card wrapper
    const productCard = swatchLabel.closest('.card-wrapper');
    if (!productCard) return;

    // Find the Globo selector
    const globoSelector = productCard.querySelector('.globo-selector-all');
    if (!globoSelector) return;

    // Get the selected variant value from the swatch
    const selectedValue = swatchInput.value;

    // Find the matching option in globo-selector-all
    const matchingOption = Array.from(globoSelector.options).find(option => {
      return option.getAttribute('data-option1') === selectedValue;
    });

    if (!matchingOption) return;

    const variantId = matchingOption.value;
    const isAvailable = matchingOption.getAttribute('data-available') === 'true';

    // Find the quick-add container
    const quickAddContainer = productCard.querySelector('.quick-add');
    if (!quickAddContainer) return;

    // Check if this is a "Choose Options" button (modal opener)
    const modalOpener = quickAddContainer.querySelector('modal-opener');
    
    if (modalOpener) {
      // Replace modal-opener with direct add-to-cart form
      const productId = productCard.querySelector('[product-swatch-id]')?.getAttribute('product-swatch-id');
      if (!productId) return;

      const sectionId = quickAddContainer.querySelector('button')?.id.split('-')[2] || 'collection';
      const formId = `quick-add-${sectionId}${productId}`;

      // Create new direct add-to-cart form
      const newForm = `
        <product-form data-section-id="${sectionId}">
          <form method="post" action="/cart/add" id="${formId}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
            <input type="hidden" name="form_type" value="product">
            <input type="hidden" name="utf8" value="✓">
            <input type="hidden" name="id" value="${variantId}" class="product-variant-id" ${!isAvailable ? 'disabled' : ''}>
            <button
              id="${formId}-submit"
              type="submit"
              name="add"
              class="quick-add__submit button button--full-width button--secondary"
              aria-haspopup="dialog"
              aria-labelledby="${formId}-submit"
              aria-live="polite"
              data-sold-out-message="true"
              ${!isAvailable ? 'disabled' : ''}
            >
              <span>
                ${isAvailable ? 'Add to cart' : 'Sold out'}
              </span>
              <span class="sold-out-message hidden">
                Sold out
              </span>
              <div class="loading__spinner hidden">
                <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                  <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                </svg>
              </div>
            </button>
          </form>
        </product-form>
      `;

      quickAddContainer.innerHTML = newForm;

      // Re-initialize product-form if the custom element exists
      if (customElements.get('product-form')) {
        const productFormElement = quickAddContainer.querySelector('product-form');
        if (productFormElement && !productFormElement.initialized) {
          // The custom element will auto-initialize
        }
      }
    } else {
      // If it's already a direct add-to-cart form, just update the variant ID
      const variantInput = quickAddContainer.querySelector('.product-variant-id');
      if (variantInput) {
        variantInput.value = variantId;
        variantInput.disabled = !isAvailable;

        const quickAddButton = quickAddContainer.querySelector('.quick-add__submit');
        if (quickAddButton) {
          quickAddButton.disabled = !isAvailable;
          const buttonText = quickAddButton.querySelector('span:first-child');
          if (buttonText) {
            buttonText.textContent = isAvailable ? 'Add to cart' : 'Sold out';
          }
        }
      }
    }
  });

  // Also listen for Globo's select dropdown changes
  document.addEventListener('change', function(e) {
    if (e.target.classList.contains('globo-selector-all')) {
      const productCard = e.target.closest('.card-wrapper');
      if (!productCard) return;

      const selectedOption = e.target.options[e.target.selectedIndex];
      const variantId = selectedOption.value;
      const isAvailable = selectedOption.getAttribute('data-available') === 'true';

      // Update the hidden variant input
      const variantInput = productCard.querySelector('.product-variant-id');
      if (variantInput) {
        variantInput.value = variantId;
        variantInput.disabled = !isAvailable;

        const quickAddButton = productCard.querySelector('.quick-add__submit');
        if (quickAddButton) {
          quickAddButton.disabled = !isAvailable;
          const buttonText = quickAddButton.querySelector('span:first-child');
          if (buttonText) {
            buttonText.textContent = isAvailable ? 'Add to cart' : 'Sold out';
          }
        }
      }
    }
  });
});